const MP_API_URL = 'https://reportesmp.netizar.com/api';

const extractErrorMessage = (data, fallback) => {
  const { error } = data || {};
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  if (error.errors?.[0]?.message) return error.errors[0].message;
  return fallback;
};

export const getTerminales = async (empresa, { limit = 10, offset = 0, storeId, posId } = {}) => {
  try {
    const params = new URLSearchParams({ empresa, limit, offset });
    if (storeId) params.append('store_id', storeId);
    if (posId) params.append('pos_id', posId);

    const response = await fetch(`${MP_API_URL}/terminales?${params.toString()}`);
    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(extractErrorMessage(data, `Error ${response.status}: ${response.statusText}`));
    }

    return data;
  } catch (error) {
    console.error('Error en getTerminales:', error);
    throw error;
  }
};

export const updateOperatingMode = async (empresa, id, operatingMode) => {
  try {
    const response = await fetch(`${MP_API_URL}/terminales/operating-mode`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ empresa, id, operating_mode: operatingMode }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(extractErrorMessage(data, `Error ${response.status}: ${response.statusText}`));
    }

    return data;
  } catch (error) {
    console.error('Error en updateOperatingMode:', error);
    throw error;
  }
};
